import {LS_KEY__COPILOT_CHATS} from 'common/src/modules/localStorage/CLLocalStorage.consts';

export default function getCopilotChatsLSKey(userId: number): string {
  return `${LS_KEY__COPILOT_CHATS}-${userId}`;
}
